import React from "react";
import PropTypes from "prop-types";
import * as types from "../../constants/ComponentConstants";

const TabNavIcon = (props) => {

    const { type, color } = props;

    const aanvraagSvg = (<svg version="1.1" id="Laag_4"  x="0px" y="0px" width="80px" height="80px" viewBox="0 0 80 80" enableBackground="new 0 0 80 80" >
            <g>
            <g>
                <path fill="#39B4E8" d="M43.324,55.928V29.813H26.977v26.115h-5.573v1l37.661-0.002v-1L43.324,55.928z M36.735,55.928h-3.168
                    v-4.439h3.168V55.928z M42.324,55.928h-4.589v-5.439h-5.168v5.439l-4.59,0.001V30.813h14.347V55.928z M39.806,45.001h-1v3.429h1
                    V45.001z M35.651,33.182h-1v3.429h1V33.182z M39.806,33.182h-1v3.429h1V33.182z M39.806,39.091h-1v3.429h1V39.091z M35.651,45.001
                    h-1v3.429h1V45.001z M31.497,39.091h-1v3.429h1V39.091z M31.497,33.182h-1v3.429h1V33.182z M31.497,45.001h-1v3.429h1V45.001z
                        M35.651,39.091h-1v3.429h1V39.091z"/>
            </g>
            </g>
            <g>
            <polygon fill="#39B4E8" points="54.672,56.429 53.672,56.429 53.672,36.813 43.324,36.813 43.324,56.429 42.324,56.429 
                42.324,35.813 54.672,35.813 	"/>
            </g>
            <g>
            <g>
                <g>
                    <rect x="45.844" y="39.091" fill="#39B4E8" width="1" height="3.429"/>
                </g>
                <g>
                    <rect x="49.998" y="39.091" fill="#39B4E8" width="1" height="3.429"/>
                </g>
            </g>
            <g>
                <g>
                    <rect x="45.844" y="45.001" fill="#39B4E8" width="1" height="3.429"/>
                </g>
                <g>
                    <rect x="49.998" y="45.001" fill="#39B4E8" width="1" height="3.429"/>
                </g>
            </g>
            </g>
            <g>
            <polygon fill="#39B4E8" points="50.559,56.284 49.559,56.284 49.559,52.488 47.391,52.488 47.391,56.284 46.391,56.284 
                46.391,51.488 50.559,51.488 	"/>
            </g>
        </svg>
    );

    const projectSvg = (<svg version="1.1" x="0px" y="0px" width="80px" height="80px" viewBox="0 0 80 80" enableBackground="new 0 0 80 80">
            <g>
                <path fill="#C6005B" d="M30.624,48.73h-1.465c-0.441,0-0.826-0.283-0.955-0.707l-4.218-13.737
                    c-0.093-0.301-0.036-0.634,0.152-0.888c0.187-0.253,0.487-0.405,0.804-0.405h19.579c0.44,0,0.825,0.283,0.955,0.705l4.416,14.385
                    l-0.956,0.293l-4.415-14.384l-19.579,0.001l4.217,13.737h1.465V48.73z"/>
            </g>
            <g>
                <path fill="#C6005B" d="M49.275,48.73H30.331v-1h18.944c0.344,0,0.643-0.221,0.744-0.551l3.739-12.181l0.956,0.293l-3.74,12.181
                    C50.744,48.225,50.062,48.73,49.275,48.73z"/>
            </g>
            <g>
                <path fill="#C6005B" d="M54.306,36.732l-0.955-0.293l1.179-3.841l-6.179,0.008c-0.06,0.211-0.146,0.47-0.245,0.766
                    c-0.104,0.31-0.221,0.66-0.343,1.048c-0.134,0.417-0.517,0.697-0.954,0.697h-1.561v-1h1.561c0.125-0.393,0.244-0.748,0.349-1.062
                    c0.097-0.288,0.18-0.539,0.244-0.748c0.129-0.419,0.51-0.701,0.949-0.701h6.185c0.314,0,0.613,0.151,0.8,0.403
                    c0.186,0.251,0.242,0.581,0.15,0.881L54.306,36.732z"/>
            </g>
            <g>
                <path fill="#C6005B" d="M29.353,48.23"/>
            </g>
            <g>
                <rect x="32.467" y="40.307" fill="#C6005B" width="9.765" height="1"/>
            </g>
            <g>
                <rect x="36.974" y="35.797" fill="#C6005B" width="1" height="9.765"/>
            </g>
        </svg>
    );

    const meSvg = (<svg version="1.1"  x="0px" y="0px" width="80px" height="80px" viewBox="0 0 80 80" enableBackground="new 0 0 80 80">
            <g id="Laag_3">
            <g>
                <path fill="#7C8034" d="M53.978,49.938H26.265c-0.179,0-0.344-0.096-0.433-0.25s-0.089-0.346,0-0.5l13.856-24
                    c0.179-0.31,0.688-0.31,0.866,0l13.856,24c0.09,0.154,0.09,0.346,0,0.5C54.321,49.842,54.156,49.938,53.978,49.938z
                        M27.131,48.938h25.98l-12.99-22.5L27.131,48.938z"/>
            </g>
            </g>
            <g id="Laag_4">
            <g>
                <path fill="#7C8034" d="M39.174,44.835c0-0.267,0.103-0.492,0.273-0.663s0.403-0.273,0.67-0.273s0.506,0.103,0.677,0.273
                    c0.164,0.171,0.274,0.396,0.274,0.663s-0.11,0.499-0.274,0.663c-0.171,0.171-0.41,0.273-0.677,0.273s-0.499-0.103-0.67-0.273
                    C39.277,45.334,39.174,45.102,39.174,44.835z M39.475,42.62c-0.034-0.267-0.068-0.937-0.096-1.784
                    c-0.027-0.841-0.048-1.839-0.062-2.748s-0.027-1.729-0.027-2.215h1.668c0,0.485-0.007,1.306-0.027,2.215s-0.041,1.907-0.068,2.748
                    c-0.027,0.848-0.062,1.518-0.096,1.784H39.475z"/>
            </g>
            </g>
        </svg>
    );

    const blSvg = (<svg version="1.1" id="Laag_2"  x="0px" y="0px" width="80px" height="80px" viewBox="0 0 80 80" enableBackground="new 0 0 80 80">
            <polygon fill="#702F8A" points="54.82,44.087 53.82,44.087 53.82,27.852 26.708,27.852 26.708,44.087 25.708,44.087 25.708,26.852 54.82,26.852 "/>
            <g>
            <g>
                <g>
                    <rect x="37.537" y="37.659" fill="#702F8A" width="1" height="3.429"/>
                </g>
                <g>
                    <rect x="41.691" y="37.659" fill="#702F8A" width="1" height="3.429"/>
                </g>
                <g>
                    <rect x="45.846" y="37.659" fill="#702F8A" width="1" height="3.429"/>
                </g>
            </g>
            <g>
                <g>
                    <rect x="29.228" y="31.659" fill="#702F8A" width="1" height="3.429"/>
                </g>
                <g>
                    <rect x="33.382" y="31.659" fill="#702F8A" width="1" height="3.429"/>
                </g>
                <g>
                    <rect x="37.537" y="31.659" fill="#702F8A" width="1" height="3.429"/>
                </g>
            </g>
            </g>
            <polygon fill="#702F8A" points="34.209,43.942 33.209,43.942 33.209,38.724 30.041,38.724 30.041,43.942 29.041,43.942 
            29.041,37.724 34.209,37.724 "/>
            <g>
            <rect x="50" y="37.659" fill="#702F8A" width="1" height="3.429"/>
            </g>
            <g>
            <g>
                <rect x="41.691" y="31.659" fill="#702F8A" width="1" height="3.429"/>
            </g>
            <g>
                <rect x="45.846" y="31.659" fill="#702F8A" width="1" height="3.429"/>
            </g>
            </g>
            <g>
            <rect x="50" y="31.659" fill="#702F8A" width="1" height="3.429"/>
            </g>
            <g>
            <g>
                <rect x="25.708" y="43.586" fill="#702F8A" width="29.112" height="1"/>
            </g>
            </g>
            <path fill="#702F8A" d="M44.859,44.903c-0.576,1.39-2.435,2.418-4.658,2.418s-4.083-1.028-4.658-2.418h-1.074
            c0.56,1.95,2.917,3.418,5.732,3.418s5.172-1.468,5.732-3.418H44.859z"/>
            <path fill="#702F8A" d="M49.267,44.903c-0.626,3.092-4.448,5.479-9.066,5.479c-4.619,0-8.441-2.388-9.068-5.479h-1.019
            c0.61,3.645,4.896,6.479,10.086,6.479c5.189,0,9.475-2.835,10.084-6.479H49.267z"/>
            <path fill="#702F8A" d="M53.462,44.903c-0.644,4.726-6.343,8.436-13.26,8.436c-6.919,0-12.62-3.71-13.263-8.436h-1.002
            c0.63,5.278,6.782,9.436,14.265,9.436c7.482,0,13.632-4.157,14.262-9.436H53.462z"/>
            <path fill="#702F8A" d="M55.127,35.676v1.366c1.896,1.998,3.008,4.395,3.008,6.971c0,6.948-8.045,12.601-17.934,12.601
            c-9.89,0-17.936-5.652-17.936-12.601c0-2.619,1.146-5.054,3.102-7.071v-1.355c-2.56,2.319-4.102,5.244-4.102,8.426
            c0,7.499,8.495,13.601,18.936,13.601c10.44,0,18.934-6.102,18.934-13.601C59.135,40.87,57.629,37.981,55.127,35.676z"/>
        </svg>
    );

    const criteriaSvg = (<svg version="1.1" id="Laag_3"  x="0px" y="0px"width="80px" height="80px" viewBox="0 0 80 80" enableBackground="new 0 0 80 80" >
            <rect x="29.367" y="47.713" fill="#FF8200" width="20.957" height="1"/>
            <rect x="31.414" y="38.692" fill="#FF8200" width="2" height="9.267"/>
            <rect x="35.412" y="34.884" fill="#FF8200" width="2" height="13.392"/>
            <rect x="39.284" y="37.105" fill="#FF8200" width="2" height="11.107"/>
            <rect x="43.155" y="31.139" fill="#FF8200" width="2" height="16.882"/>
            <rect x="47.09" y="40.152" fill="#FF8200" width="2" height="7.87"/>
            <path fill="#FF8200" d="M53.34,53.041h-27c-0.276,0-0.5-0.224-0.5-0.5v-27c0-0.276,0.224-0.5,0.5-0.5h27c0.276,0,0.5,0.224,0.5,0.5
            v27C53.84,52.817,53.616,53.041,53.34,53.041z M26.839,52.041h26v-26h-26V52.041z"/>
        </svg>
    );

    const dieninSvg = (<svg version="1.1" id="Laag_5" x="0px" y="0px" width="80px" height="80px" viewBox="0 0 80 80" enableBackground="new 0 0 80 80" >
            <path fill="#009639" d="M42.209,42.377c-0.006,0-0.012,0-0.017,0c-0.153-0.006-0.296-0.081-0.387-0.204l-5.538-7.554
            c-0.163-0.223-0.115-0.535,0.108-0.699c0.222-0.164,0.534-0.116,0.699,0.108l5.162,7.041l11.531-13.685
            c0.181-0.211,0.496-0.237,0.705-0.06c0.211,0.178,0.238,0.493,0.061,0.705L42.592,42.199C42.496,42.312,42.356,42.377,42.209,42.377
            z"/>
            <path fill="#009639" d="M50.585,34.486c0.85,1.659,1.339,3.532,1.339,5.52c0,6.705-5.455,12.16-12.16,12.16
            s-12.16-5.455-12.16-12.16s5.455-12.16,12.16-12.16c3.496,0,6.644,1.492,8.864,3.862l0.673-0.744c-2.4-2.53-5.783-4.118-9.537-4.118
            c-7.256,0-13.16,5.904-13.16,13.16c0,7.257,5.904,13.16,13.16,13.16c7.257,0,13.16-5.903,13.16-13.16
            c0-2.288-0.589-4.439-1.62-6.315L50.585,34.486z"/>
        </svg>
    );

    const financieleVerantwoordingSvg = (<svg id="Laag_4" viewBox="0 0 80 80">
            <path fill="#e9a2b2" d="M52.826,57.076H27.012V22.058h18.457l7.357,7.358V57.076z M28.012,56.076h23.814V29.83l-6.771-6.772H28.012
                V56.076z"/>
            <polygon fill="#e9a2b2" points="52.326,30.123 44.76,30.123 44.76,22.557 45.76,22.557 45.76,29.123 52.326,29.123 "/>
            <g>
                <path fill="#e9a2b2" d="M35.224,42.376h0.742c-0.008-0.07-0.016-0.148-0.016-0.227s0-0.156,0-0.234c0-0.086,0-0.172,0-0.258
                    s0.008-0.172,0.016-0.258h-1.117l-0.031-0.031l0.406-1.094h0.922c0.312-1.195,0.984-2.109,1.898-2.727
                    c0.906-0.617,2.055-0.93,3.335-0.93c0.617,0,1.383,0.07,2.102,0.32l-0.391,1.086c-0.648-0.188-1.242-0.273-1.836-0.273
                    c-0.929,0-1.742,0.211-2.406,0.641s-1.164,1.062-1.445,1.883h4.952l0.031,0.031l-0.406,1.094h-4.804
                    c-0.016,0.172-0.023,0.352-0.023,0.531c0,0.078,0,0.156,0,0.227s0.008,0.148,0.016,0.219h4.421l0.031,0.086l-0.406,1.094h-3.804
                    c0.281,0.812,0.773,1.445,1.406,1.875s1.422,0.656,2.273,0.656c0.719,0,1.477-0.164,2.258-0.508l0.055,0.031v1.109
                    c-0.836,0.344-1.656,0.508-2.445,0.508c-1.133,0-2.188-0.336-3.023-0.969c-0.844-0.625-1.477-1.547-1.781-2.703h-1.305
                    l-0.031-0.031L35.224,42.376z"/>
            </g>
        </svg>
    );

    let svgcontent = {
        "ICON_AANVRAAG": aanvraagSvg,
        "ICON_PROJECT": projectSvg,
        "ICON_MINIMALEEISEN": meSvg,
        "ICON_FINANCIEEL": financieleVerantwoordingSvg,
        "ICON_BOVENLOKALITEIT": blSvg,
        "ICON_BEOORDELINGSCRITERIA": criteriaSvg,
        "ICON_INDIENEN": dieninSvg,
        "ICON_FINANCIELEVERANTWOORDING": financieleVerantwoordingSvg
    };

    let svgpaths = svgcontent[types.ICON_AANVRAAG];
    if (type) {
        svgpaths = svgcontent[type];
    }

    return (svgpaths);
};

TabNavIcon.propTypes = {
    type: PropTypes.string,
    color: PropTypes.string
};

export default TabNavIcon;